import { Injectable } from '@angular/core';
import { ApiHttpClient } from 'app/http/clients/api';
import { Application } from 'app/models/dto/deal-application.model';
import { Observable } from 'rxjs';
import { ApplicationPackage } from './application.model';

@Injectable({
  providedIn: 'root'
})
export class ApplicationService {

  constructor(private http: ApiHttpClient) { }

  post(newPackage: ApplicationPackage): Observable<Application> {
    return this.http.post<Application>('/application', newPackage);
  }

  getDealApplications(dealId: number): Observable<Application[]> {
    return this.http.get<Application[]>(`/application/${dealId}/deal`);
  }

  getBorrowerApplications(borrowerId: number): Observable<Application[]> {
    return this.http.get<Application[]>(`/borrower/${borrowerId}/applications`);
  }
}
